module.exports = __webpack_public_path__ + "static/diamonds-4e1dc60b4c663ba76f111ce071c8d009.jpg";